import i18next from 'i18next';

import EntityFactory from '../factory/famly-app';
import GoHomeWithChildrenGroup from './model';

export default EntityFactory.createEntity({
    domain: 'ENTITIES/GO_HOME_WITH_CHILDREN',
    entityName: i18next.t('child'),
    model: GoHomeWithChildrenGroup,
    groupByKeys: ['childId'],
    entityIdentifier: 'groupId',
    apiDescription: {
        fetchAll: {
            url: 'v2/childcheckins/gohomewith',
            requestPayload: ({childId}) => ({
                childId,
                id: childId,
            }),
            locateResponse: response => response,
        },
    },
});
